"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

/**
 * Copyright (c) 2015-present, Zippy Technologies
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

exports.default = function (props) {
  var itemStyle = props.itemStyle,
      itemOverStyle = props.itemOverStyle,
      itemOverClassName = props.itemOverClassName,
      itemActiveStyle = props.itemActiveStyle,
      itemActiveClassName = props.itemActiveClassName,
      itemDisabledStyle = props.itemDisabledStyle,
      itemDisabledClassName = props.itemDisabledClassName,
      itemExpandedStyle = props.itemExpandedStyle,
      itemExpandedClassName = props.itemExpandedClassName,
      cellStyle = props.cellStyle,
      itemFocusedStyle = props.itemFocusedStyle,
      itemFocusedClassName = props.itemFocusedClassName,
      itemOverFocusedStyle = props.itemOverFocusedStyle;


  return {
    style: itemStyle,
    overStyle: itemOverStyle,
    overClassName: itemOverClassName,
    activeStyle: itemActiveStyle,
    activeClassName: itemActiveClassName,
    disabledStyle: itemDisabledStyle,
    disabledClassName: itemDisabledClassName,
    expandedStyle: itemExpandedStyle,
    expandedClassName: itemExpandedClassName,
    focusedStyle: itemFocusedStyle,
    focusedClassName: itemFocusedClassName,
    overFocusedStyle: itemOverFocusedStyle,
    cellStyle: cellStyle
  };
};